import { Arrows } from "..";
import { Anchor, Container, Content } from "./styles";

export function Conditional({ job, theme }) {
  const cellWidth = parseInt(theme.cellWidth);
  const startTime = job.start.getHours();
  const leftOffset = (startTime * cellWidth) / 24 + 10.5;
  const status = job.status;

  return (
    <Container style={{
      top: theme.conditionalStyle.top,
      left: leftOffset + "px"

    }} >
      <Content style={{
        height: theme.conditionalStyle.height,
        width: theme.conditionalStyle.width,

      }} status={status}>
        <Anchor className="top_anchor" id={"anchor_" + job.id} />
        <Anchor className="bottom_anchor" id={job.id} />
      </Content>
      <Arrows job={job} />
    </Container>
  );
}
